import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Form, Modal, Space, Typography, Alert } from "antd";
import { CheckCircleOutlined, FormOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { getReleaseFormApi, releaseFormApi } from "../../../api/formsColaboradoresReleaseForms";
import { DescriptiveQuestion } from "./components/descriptive-question";
import { DateQuestion } from "./components/date-question";
import { ObjectiveQuestion } from "./components/objective-question";
import { MultipleQuestion } from "./components/multiple-question";
import { DataLoading } from "../../../components/loading";

const { Text } = Typography;

const getValueFromOptionsObective = (options) => {
  if (!Array.isArray(options)) {
    return null;
  }
  for (const op of options) {
    if (op.situacao === 1) {
      return op.id;
    }
  }
};

const getValueFromOptionsMultiple = (options) => {
  if (!Array.isArray(options)) {
    return null;
  }
  let value = [];
  for (const op of options) {
    if (op.situacao === 1) {
      value.push(op.id);
    }
  }

  return value;
};

export const FormulariosColaboradoresLancamento = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [messageApi, contextMessage] = message.useMessage();
  const [loadingData, setLoadingData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [formulario, setFormulario] = useState(null);
  const { id_formularios_lancamento } = useParams();

  useEffect(() => {
    if (id_formularios_lancamento) {
      getReleaseForm(id_formularios_lancamento);
    }
  }, [id_formularios_lancamento]);

  const getReleaseForm = async (id) => {
    setLoadingData(true);
    try {
      const { statusCode, response } = await getReleaseFormApi(id);
      if (statusCode === 200) {
        if (!response.data) {
          navigate("/formularios-colaboradores/pencencias");
        }
        setFormulario(response.data);
      } else {
        navigate("/formularios-colaboradores/pencencias");
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
      navigate("/formularios-colaboradores/pencencias");
    } finally {
      setLoadingData(false);
    }
  };

  const releaseForm = async (data) => {
    setLoading(true);
    messageApi.open({
      key: "enviar_formulario",
      type: "loading",
      content: "Enviando formulário...",
      duration: 0,
    });
    try {
      const { statusCode, response } = await releaseFormApi(data);
      if (statusCode === 200) {
        messageApi.open({
          key: "enviar_formulario",
          type: "success",
          content: "Registro inserido com sucesso!",
          duration: 2,
        });
        navigate("/formularios-colaboradores/pencencias");
      } else {
        messageApi.open({
          key: "enviar_formulario",
          type: "error",
          content: response?.message,
          duration: 2,
        });
      }
    } catch (error) {
      messageApi.open({
        key: "enviar_formulario",
        type: "error",
        content: "Ops, houve algum erro!",
        duration: 2,
      });
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = (formData) => {
    const releaseFormData = {
      questoes: formData,
      id_formularios_lancamento: id_formularios_lancamento,
    };
    releaseForm(releaseFormData);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Formulários Colaboradores"
              onClickBack={() => navigate("/formularios-colaboradores/pencencias")}
            />
            <HeaderTitle
              title={["Formulários Pendências", "Lançamento"]}
              subtitle={`Formulário Lançamento`}
              icon={<FormOutlined />}
              loading={loading}
            />
            <Divider />

            {loadingData && <DataLoading />}
            {!loadingData && (
              <>
                <Card
                  title={
                    <Text style={{ fontSize: 26, color: "#60b565" }} strong>
                      {formulario?.campanha}
                    </Text>
                  }
                  bordered={false}
                  bodyStyle={{ padding: "3%", marginBottom: 20 }}>
                  <Space direction="vertical">
                    <Text className="line-break" style={{ fontSize: 18, fontWeight: "bold" }}>
                      Formulário: {formulario?.formulario}
                    </Text>

                    <Text className="line-break" style={{ fontSize: 18, fontWeight: "bold" }}>
                      Parâmetro Avaliado:{" "}
                      {formulario?.tipo_parametro === 1 ? formulario?.colaborador : formulario?.descricao_parametro}
                    </Text>

                    <Text className="line-break" style={{ fontSize: 14 }}>
                      {formulario?.observacoes_formulario ?? ""}
                    </Text>

                    <Alert message="Atenção! Sua identidade não será revelada neste formulário." type="info" showIcon />
                  </Space>
                </Card>

                <Form
                  form={form}
                  onFinish={onSubmit}
                  layout="vertical"
                  autoComplete="off"
                  onFinishFailed={() => message.error("Há campos não preenchidos!")}>
                  {formulario?.grupos?.map((grupo) => {
                    return (
                      <Card
                        key={grupo.id}
                        title={grupo.descricao}
                        bordered={false}
                        bodyStyle={{ padding: "3%", marginBottom: 20 }}>
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                          {grupo?.questoes?.map((questao) => {
                            if (questao.tipo == 1) {
                              return (
                                <DescriptiveQuestion
                                  key={questao.id}
                                  id={questao.id}
                                  defaultValue={questao.resposta ?? ""}
                                  loading={loading}
                                  obrigatorio={questao.obrigatorio}
                                  questao={questao.questao}
                                />
                              );
                            }

                            if (questao.tipo == 2) {
                              return (
                                <DateQuestion
                                  key={questao.id}
                                  defaultValue={questao.resposta ?? ""}
                                  id={questao.id}
                                  loading={loading}
                                  obrigatorio={questao.obrigatorio}
                                  questao={questao.questao}
                                />
                              );
                            }

                            if (questao.tipo == 3) {
                              return (
                                <ObjectiveQuestion
                                  key={questao.id}
                                  id={questao.id}
                                  loading={loading}
                                  defaultValue={getValueFromOptionsObective(questao.alternativas)}
                                  obrigatorio={questao.obrigatorio}
                                  questao={questao.questao}
                                  alternativas={questao.alternativas}
                                />
                              );
                            }

                            if (questao.tipo == 4) {
                              return (
                                <MultipleQuestion
                                  key={questao.id}
                                  id={questao.id}
                                  loading={loading}
                                  defaultValue={getValueFromOptionsMultiple(questao.alternativas)}
                                  obrigatorio={questao.obrigatorio}
                                  questao={questao.questao}
                                  alternativas={questao.alternativas}
                                />
                              );
                            }
                          })}
                        </Row>
                      </Card>
                    );
                  })}
                  <Card bordered={false} bodyStyle={{ padding: "3%" }}>
                    <Button
                      icon={<CheckCircleOutlined />}
                      onClick={() => {
                        modal.confirm({
                          title: "Deseja finalizar o formulário?",
                          okText: "Sim",
                          cancelText: "Cancelar",
                          onOk() {
                            form.submit();
                          },
                        });
                      }}
                      loading={loading}
                      type="primary"
                      size="large">
                      Finalizar Formulário
                    </Button>
                  </Card>
                </Form>
              </>
            )}
          </div>
        </Col>
      </Col>
      {contextHolder}
      {contextMessage}
    </Row>
  );
};
